import React, { useState, useEffect } from 'react';
import StatsCard from '../components/StatsCard';
import ObservationGrid from '../components/ObservationGrid';
import Pagination from '../components/Pagination';
import { Leaf, Camera } from 'lucide-react';
import './Dashboard.css';

const USER_ID = 'gowthama_pandian';
const TAXON_ID = '47792'; // Odonata
const PER_PAGE = 50;

const Dashboard = () => {
  const [observations, setObservations] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [speciesCount, setSpeciesCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const speciesRes = await fetch(`https://api.inaturalist.org/v1/observations/species_counts?user_id=${USER_ID}&taxon_id=${TAXON_ID}`);
        const speciesData = await speciesRes.json();
        setSpeciesCount(speciesData.total_results || 0);
      } catch (err) {
        console.error("Failed to fetch species count", err);
      }
    };
    fetchStats();
  }, []);

  useEffect(() => {
    const fetchObservations = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const res = await fetch(
          `https://api.inaturalist.org/v1/observations?user_id=${USER_ID}&taxon_id=${TAXON_ID}&per_page=${PER_PAGE}&page=${currentPage}`
        );
        const data = await res.json();
        setObservations(data.results || []);
        setTotalResults(data.total_results || 0);
      } catch (err) {
        setError("Failed to load observations. Please check your connection.");
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchObservations();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const totalPages = Math.ceil(totalResults / PER_PAGE);

  return (
    <div className="dashboard-page">
      <main className="container">

        <div className="stats-container">
          <StatsCard 
            label="Total Observations" 
            value={totalResults.toLocaleString()} 
            icon={<Camera size={24} />} 
            color="emerald"
          />
          <StatsCard 
            label="Unique Species" 
            value={speciesCount.toLocaleString()} 
            icon={<Leaf size={24} />} 
            color="amber"
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        {isLoading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Gathering observations...</p>
          </div>
        ) : (
          <>
            <ObservationGrid observations={observations} />
            <Pagination 
              currentPage={currentPage} 
              totalPages={totalPages} 
              onPageChange={setCurrentPage} 
            />
          </>
        )}
      </main>
    </div>
  );
};

export default Dashboard;
